<template>
  <div class="myAllies" v-loading="listLoading">
    <div class="myAlliesFilters">
      <button
        v-for="tab in levelTabList"
        :key="tab.value"
        type="button"
        class="myAlliesFilterBtn"
        :class="{ 'is-active': activeLevel === tab.value }"
        @click="switchLevelTab(tab.value)"
      >
        {{ tab.label }}
      </button>
    </div>

    <div v-if="filteredAlliesList.length" class="myAlliesGrid">
      <div
        v-for="(item, index) in filteredAlliesList"
        :key="item.id || index"
        class="myAlliesCard"
        @click="toDetails(item)"
      >
        <div class="myAlliesCardLogo">
          <img
            v-if="item.image"
            :src="item.image"
            :alt="item.name"
            class="myAlliesCardLogoImg"
          />
          <span v-else class="myAlliesCardLogoPlaceholder">{{
            (item.abbr || item.name || "").slice(0, 2)
          }}</span>
        </div>
        <div class="myAlliesCardBody">
          <h3 class="myAlliesCardTitle">{{ item.name }}</h3>
          <div class="myAlliesCardBadgeList" v-if="item.equityClassifyNames">
            <div
              v-for="tag in item.equityClassifyNames.split('、')"
              :key="tag"
              class="myAlliesCardBadge"
            >
              <img
                v-if="levelIconMap[tag.trim()]"
                :src="levelIconMap[tag.trim()]"
                :alt="tag"
                class="myAlliesCardBadgeIcon"
              />
              <!-- <span class="myAlliesCardBadgeText">{{ tag.trim() }}</span> -->
            </div>
          </div>
          <div class="myAlliesCardLocation">
            <i class="el-icon-location-outline"></i>
            <span
              >所在地：{{
                item.address || item.businessAddress || "暂无"
              }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <el-empty
      v-else
      class="myAlliesEmpty"
      description="暂无盟友数据"
      :image-size="120"
    />

    <div class="myAlliesPage" v-if="filteredAlliesList.length">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="pages.total"
        :current-page="pages.page"
        :page-size="pages.size"
        @current-change="handlePageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import L1 from "@/assets/images/L1.png";
import L2 from "@/assets/images/L2.png";
import L3 from "@/assets/images/L3.png";
import L4 from "@/assets/images/L4.png";
import { getAllyList } from "@/api/lx";

/**
 * 我的盟友模块
 */
export default {
  name: "MyAllies",
  props: {
    company: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeLevel: "all",
      listLoading: false,
      alliesList: [],
      pages: {
        page: 1,
        total: 0,
        size: 10,
      },
      levelTabList: [
        { label: "全部", value: "all" },
        { label: "L1", value: "L1" },
        { label: "L2", value: "L2" },
        { label: "L3", value: "L3" },
        { label: "L4", value: "L4" },
      ],
      levelIconMap: {
        L1,
        L2,
        L3,
        L4,
      },
    };
  },
  computed: {
    filteredAlliesList() {
      return this.alliesList;
    },
  },
  watch: {
    company: {
      handler() {
        this.fetchAlliesList();
      },
      deep: true,
    },
  },
  created() {
    this.fetchAlliesList();
  },
  methods: {
    switchLevelTab(level) {
      if (this.activeLevel === level) return;
      this.activeLevel = level;
      this.pages.page = 1;
      this.fetchAlliesList();
    },

    /**
     * 拉取盟友列表
     */
    fetchAlliesList() {
      this.listLoading = true;
      const params = {
        page: this.pages.page,
        size: this.pages.size,
        equityClassifyName:
          this.activeLevel === "all" ? undefined : this.activeLevel,
      };
      getAllyList(params)
        .then((res) => {
          if (res.code === 200) {
            this.alliesList = res.data.records || [];
            this.pages.total = res.data.total || 0;
          } else {
            this.$message.error(res.msg || "获取盟友数据失败");
          }
        })
        .catch((err) => {
          console.error(err);
          this.$message.error("获取盟友数据错误");
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 分页改变
     */
    handlePageChange(page) {
      this.pages.page = page;
      this.fetchAlliesList();
    },

    /**
     * 跳转详情
     */
    toDetails(item) {
      this.$router.push({
        name: "communityDetails",
        query: { id: item.id },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.myAllies {
  width: 100%;
  min-height: 200px;
}
.myAlliesFilters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
}
.myAlliesFilterBtn {
  appearance: none;
  padding: 4px 24px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s, background 0.2s;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #6b7280;
  &:hover {
    border-color: #00d2b2;
    color: #00d2b2;
  }
  &.is-active {
    border-color: #00d2b2;
    background: #00d2b2;
    color: #fff;
  }
}
.myAlliesGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
}
.myAlliesCard {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  padding: 24px;
  background: #f9fafb;
  border-radius: 8px;
  transition: box-shadow 0.2s;
  cursor: pointer;
  &:hover {
    box-shadow: 0 4px 12px rgba(0, 22, 26, 0.08);
  }
}
.myAlliesCardLogo {
  width: 128px;
  height: 128px;
  flex-shrink: 0;
  background: #00d8c3;
  border: 1px solid #f3f4f6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.myAlliesCardLogoImg {
  width: 100%;
  height: 100%;
  // object-fit: contain;
  // 图片四周裁剪
  object-fit: cover;
  // padding: 8px;
  box-sizing: border-box;
}
.myAlliesCardLogoPlaceholder {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
}
.myAlliesCardBody {
  flex: 1;
  min-width: 0;
  padding-top: 8px;
}
.myAlliesCardTitle {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
  line-height: 1.4;
}
.myAlliesCardBadgeList {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  .myAlliesCardBadge {
    margin-bottom: 0;
  }
}
.myAlliesCardBadge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  // padding: 4px 8px;
  // background: #fff;
  // border: 1px solid #f3f4f6;
  border-radius: 4px;
}
.myAlliesCardBadgeIcon {
  width: 36px;
  height: 36px;
  object-fit: contain;
}
.myAlliesCardBadgeText {
  font-size: 12px;
  color: #6b7280;
}
.myAlliesCardLocation {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #9ca3af;
  i {
    font-size: 16px;
  }
}
.myAlliesCardStats {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px dashed #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.myAlliesCardStatItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  .statLabel {
    color: #6b7280;
  }
  .statValue {
    font-weight: 600;
    color: #374151;
    &.highlight {
      color: #00d2b2;
    }
  }
}
.myAlliesEmpty {
  padding: 48px 0;
}
.myAlliesPage {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
</style>
